import { connect } from "react-redux";
import { compose } from "redux";

import withTrackingHasPageBeenVisited from "app/pages/sales-intelligence/hoc/withTrackingHasPageBeenVisited";
import type { RootState } from "single-spa/store/types";

import withLegacyWorkspacesFetch from "../../hoc/withLegacyWorkspacesFetch";
import withSecondaryBarSet from "../../hoc/withSecondaryBarSet";
import withSignalsSubscription from "../../hoc/withSignalsSubscription";
import { selectOpportunityLists } from "../../sub-modules/opportunities/store/selectors";

import HomePage from "./HomePage";

const mapStateToProps = (state: RootState) => ({
    opportunityLists: selectOpportunityLists(state),
});

const HomePageContainer = compose(
    connect(mapStateToProps, null),
    withLegacyWorkspacesFetch,
    withSecondaryBarSet("SalesIntelligenceHome"),
    withSignalsSubscription,
    withTrackingHasPageBeenVisited,
)(HomePage);

export default HomePageContainer;
